// extracted by mini-css-extract-plugin
export var bg = "waystogetcard-module--bg--hckPp";
export var container = "waystogetcard-module--container--gRYcz";
export var head = "waystogetcard-module--head--u2UPM";
export var item = "waystogetcard-module--item--0Z+3b";
export var list = "waystogetcard-module--list--ZgBVj";